var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 10.8332C8.68991 11.3117 9.1465 11.7075 9.67082 11.994C10.1952 12.2805 10.775 12.4508 11.3709 12.4935C11.9669 12.5362 12.565 12.4502 13.1248 12.2414C13.6846 12.0326 14.193 11.7058 14.6154 11.2832L17.1154 8.78322C17.8744 7.99738 18.2943 6.94487 18.2848 5.85238C18.2754 4.7599 17.8371 3.71485 17.0646 2.94231C16.2921 2.16978 15.247 1.73157 14.1545 1.72208C13.0621 1.71259 12.0095 2.13256 11.2237 2.89156L9.79037 4.31656",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6678 9.16677C11.3099 8.68833 10.8533 8.29245 10.329 8.00599C9.80469 7.71953 9.22489 7.54918 8.62893 7.50649C8.03298 7.46381 7.43482 7.5498 6.87502 7.75862C6.31522 7.96744 5.80688 8.29421 5.38448 8.71677L2.88448 11.2168C2.12548 12.0026 1.70551 13.0551 1.715 14.1476C1.72449 15.2401 2.1627 16.2851 2.93523 17.0577C3.70777 17.8302 4.75282 18.2684 5.8453 18.2779C6.93779 18.2874 7.9903 17.8674 8.77614 17.1084L10.2011 15.6834",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.dbb9a195.svg";
export { ForwardRef as ReactComponent };